<template>
  <v-col
    class="pa-0 fill-height"
  >
    <report-manager />

    <v-container
      v-if="isReadingReport"
      class="ma-0 fill-height"
      fluid
    >
      <v-row
        v-if="haveSelectedSearch"
        class="align-self-start fill-height"
      >
        <v-col
          :class="isLayoutFullScreen ? 'px-0' : ''"
        >
          <report-bar :favorites="favorites" />
          <metric-bar :metrics="metrics" />

          <data-table
            ref="table"
            :actions="actions"
            :data-groups="currentDataTableGroups"
          />

          <slot name="report-modals" />
        </v-col>
      </v-row>
    </v-container>
  </v-col>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'

import mixin from 'src/utils/mixin'

const { mapState: mapLayoutState } = createNamespacedHelpers('layout')

export default {
  name: 'ReportContainer',
  components: {
    DataTable: () => import('src/tools/components/table/DataTable'),
    MetricBar: () => import('src/dashboard/components/MetricBar'),
    ReportBar: () => import('src/dashboard/components/ReportBar'),
    ReportManager: () => import('src/report/components/ReportManager'),
  },
  mixins: [mixin],
  props: {
    actions: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    ...mapLayoutState({
      $isLayoutFullScreen: (state) => state.isLayoutFullScreen,
    }),
    isLayoutFullScreen() {
      return this.$isLayoutFullScreen
    },
  },
}
</script>

<style lang="scss" scoped>
@import "~src/styles/variables";

</style>
